import { useCallback, useState } from 'react';
import type { FixedRule } from 'repository/timekeeper/@types/FixedRuleModel';
import { TimekeeperService } from 'services/TimekeeperService';

const timekeeperService = new TimekeeperService();

export const useFixRuleQuery = () => {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<FixedRule[]>([]);

    const loadData = useCallback(async () => {
        try {
            setLoading(true);
            const data = await timekeeperService.fixed_rule.getFixedRules();
            const orderedData = data.sort((a, b) => a.name.localeCompare(b.name, 'es', { sensitivity: 'base' }));
            setRows(orderedData as FixedRule[]);
        } catch (error) {
            console.error('Error loading fixed rules:', error);
            setLoading(false);
            setRows([]);
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        rows,
        loading,
        setRows,
        loadData,
        setLoading,
    };
};
